import {
  AddressView,
  Label,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@gearbox-protocol/deploy-tools-ui";
import type { OnchainSDK } from "@gearbox-protocol/sdk/onchain";
import type { FC } from "react";
import type { Address } from "viem";

export interface CreditManagerSelectorProps {
  sdk: OnchainSDK;
  label: string;
  value?: Address;
  onChange: (value: Address) => void;
  values: Address[];
}

export const CreditManagerSelector: FC<CreditManagerSelectorProps> = props => {
  const { label, value, onChange, values, sdk } = props;
  return (
    <div className="grid grid-cols-values-2 gap-2">
      <div className="flex items-center">
        <Label>{label}</Label>
      </div>
      <div>
        <Select value={value} onValueChange={onChange}>
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder={label} />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              <SelectLabel>Tokens</SelectLabel>
              {values.map(address => (
                <SelectItem key={address} value={address}>
                  {sdk.marketRegister.findCreditManager(address)?.name ??
                    address}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
      <div />
      <div>
        <AddressView
          address={value ?? "0x0"}
          className="text-mono text-sm"
          compact
        />
      </div>
    </div>
  );
};
